import MdeEditorContainer from "../../../../Components/Miscellaneous/Editors/MdeEditor/MdeEditorContainer";

const MdeEditor = () => {
  return <MdeEditorContainer />;
};

export default MdeEditor;
